import type { QueryParams } from "../../types";

export const giftOrdersKeys = {
  all: ["giftOrders"] as const,
  list: (params: QueryParams) =>
    [...giftOrdersKeys.all, "list", params] as const,
};
